import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { BaseComponentCanDeactivate } from 'app/@auth/guards/changes.guard';

@Component({
  selector: 'ngx-premium-modal',
  templateUrl: './premium-modal.component.html',
  styleUrls: ['./premium-modal.component.scss']
})
export class PremiumModalComponent
  extends BaseComponentCanDeactivate
  implements OnInit {

  CloseCallBack = null;
  OnPremiumCallBack = null;

  constructor(
    private dialogRef: NbDialogRef<PremiumModalComponent>,
    private dialogService: NbDialogService,
    private router: Router,) {

    super(dialogService);

  }

  ngOnInit(): void {
  }

  onPremium(): void {
    if (this.dialogRef) this.dialogRef.close();
    if (this.OnPremiumCallBack != null) this.OnPremiumCallBack();
    this.router.navigateByUrl('/pages/CalorieFriend/manage-subscription');

  }
  Close() {
    if (this.CloseCallBack != null) this.CloseCallBack();
    if (this.dialogRef) this.dialogRef.close();
  }


}
